// tslint:disable-next-line: no-submodule-imports
import useStyles from 'isomorphic-style-loader/useStyles';
import React, { Fragment, useEffect, useRef, useState, useCallback, useContext } from 'react';
import { shallowEqual, useSelector, useDispatch } from 'react-redux';
import { bindHandler, computeElementOffsetFromPage, dispatchSkyfireMethods } from '../../utils';
import { globals } from '../../utils/globals';
import * as messageStyles from '../../views/Message.scss';
import Template from '../../Contexts/Template';
export default function MessageWidget(props) {
    var _a, _b;
    // Grab data from props and Redux store.
    const { data } = props;
    const { message, subMessage, subMessageLink, subMessageLinkText, subMessageSuffix, buttonText, buttonPrimaryLink, image, header, } = data;
    const { windowHeight } = useSelector((state) => state.BrowserState, shallowEqual);
    const messageWidgetRef = useRef(null);
    const [topMarginStyles, setTopMarginStyles] = useState({ marginTop: 0, opacity: 0 });
    const [hasRendered, setHasRendered] = useState(false);
    useStyles(messageStyles);
    const computeTopMargin = () => {
        var _a;
        let marginTop;
        if ((_a = messageWidgetRef) === null || _a === void 0 ? void 0 : _a.current) {
            const offsetTop = computeElementOffsetFromPage(messageWidgetRef.current).offsetTop;
            const elementHeight = messageWidgetRef.current.offsetHeight;
            const parent = messageWidgetRef.current.parentElement || globals.window.document.body;
            const parentOffset = parent.offsetTop;
            const containerHeight = globals.window.document.body.offsetHeight - parentOffset;
            // If we compute again when img loads, add back the existing marginTop since we subtracted in computeElementOffsetFromPage
            marginTop = Math.max(0, Math.min(Math.max(0, containerHeight / 2 -
                offsetTop -
                elementHeight / 2 +
                topMarginStyles.marginTop), windowHeight / 3 - elementHeight)); // safeguard against multiple callbacks
            setTopMarginStyles({ marginTop, opacity: 1 });
        }
    };
    useEffect(() => {
        if (!hasRendered) {
            setHasRendered(true);
            return;
        }
        computeTopMargin();
    }, [hasRendered]);
    const dispatch = useDispatch();
    const currTemplate = useContext(Template);
    const onItemSelected = useCallback(() => {
        var _a;
        if (currTemplate) {
            dispatchSkyfireMethods(dispatch, currTemplate, (_a = buttonPrimaryLink) === null || _a === void 0 ? void 0 : _a.onItemSelected);
        }
    }, []);
    const subMessageLinkElement = subMessageLink && subMessageLinkText ? (React.createElement(Fragment, { key: subMessageLinkText },
        ' ',
        React.createElement("music-link", { className: messageStyles.subMessageLink, href: (_a = subMessageLink) === null || _a === void 0 ? void 0 : _a.deeplink, onClick: bindHandler(props.handleSelected, null, (_b = subMessageLink) === null || _b === void 0 ? void 0 : _b.onItemSelected) }, subMessageLinkText))) : null;
    const buttonElement = buttonText && buttonPrimaryLink ? (React.createElement(Fragment, { key: buttonText },
        ' ',
        React.createElement("music-button", { id: buttonText, variant: "glass", size: "medium", onClick: bindHandler(onItemSelected, null) }, buttonText))) : null;
    return (React.createElement("div", { ref: messageWidgetRef, style: topMarginStyles },
        React.createElement("div", { className: messageStyles.messageContainer },
            image && (React.createElement("img", { className: messageStyles.messageImage, src: image, onLoad: computeTopMargin })),
            header && React.createElement("h1", { className: "music-headline-4" }, header),
            React.createElement("p", { className: messageStyles.messageBody },
                React.createElement("p", { className: 'music-primary-text' }, message)),
            subMessage && (React.createElement("p", { className: messageStyles.messageBody },
                React.createElement("p", { className: 'music-primary-text' },
                    subMessage,
                    subMessageLinkElement,
                    subMessageSuffix))),
            buttonElement && React.createElement("span", null, buttonElement))));
}
